var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "inherit",
    clipRule: "evenodd",
    d: "M3.63365 9.5598C4.51951 8.20597 6.74161 5.5 10.2727 5.5C13.8038 5.5 16.0259 8.20597 16.9118 9.5598C17.09 9.83214 17.09 10.1679 16.9118 10.4402C16.0259 11.794 13.8038 14.5 10.2727 14.5C6.74161 14.5 4.51951 11.794 3.63365 10.4402C3.45545 10.1679 3.45545 9.83214 3.63365 9.5598ZM10.2727 4.5C6.20191 4.5 3.71903 7.60295 2.79687 9.01227C2.40104 9.61719 2.40104 10.3828 2.79687 10.9877C3.71903 12.3971 6.20191 15.5 10.2727 15.5C14.3435 15.5 16.8264 12.3971 17.7486 10.9877C18.1444 10.3828 18.1444 9.61719 17.7486 9.01227C16.8264 7.60295 14.3435 4.5 10.2727 4.5ZM10.2727 7C8.61822 7 7.27918 8.34437 7.27918 10C7.27918 11.6556 8.61822 13 10.2727 13C10.3142 13 10.3555 12.9992 10.3966 12.9975C10.4309 12.9992 10.4654 13 10.5 13C10.915 13 11.3063 12.8787 11.6508 12.664C12.611 12.1641 13.2663 11.1582 13.2663 10C13.2663 8.84178 12.611 7.8359 11.6508 7.33603C11.3063 7.12133 10.915 7 10.5 7C10.4654 7 10.4309 7.00085 10.3966 7.00252C10.3555 7.00084 10.3142 7 10.2727 7Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2ebaae35d2e675a9aa0f5df1a0c233f1.svg";
export { ForwardRef as ReactComponent };